module.exports = __webpack_public_path__ + "static/coveatcooperlakes-afd3129a0b5c4f7d24f29c5fe2624d93.jpg";